<template>
  <div class="common-box margin-l6 myInfo">
    <div class="myInfo-header">
      <a href="javascript:;" class="myInfo-attestation" @click="perfectClick">{{perfectText}}</a>
      <img v-if="$commonJs.getSex(id) == '女'" src="https://trade.myfund.com/kfit/img/new20200910/20200911_woman.png" alt="">
      <img v-else src="https://trade.myfund.com/kfit/img/new20200910/20200911_man.png" alt="">
      <p class="myInfo-username">{{username}}</p>
    </div>
    <div class="myInfo-con">
      <p class="myInfo-title">个人资料</p>
      <ul class="myInfo-personalInfo">
        <li>
          <span>性别</span>
          <span>{{$commonJs.getSex(id)}}</span>
        </li>
        <li>
          <span>出生日期</span>
          <span>{{$commonJs.getBirthday(id)}}</span>
        </li>
        <li>
          <span>手机号码</span>
          <span>{{phone.substr(0,3) + "****" + phone.substr(7)}}</span>
        </li>
        <li>
          <span>证件类型</span>
          <span>{{certificatetype}}</span>
        </li>
        <li>
          <span>证件号码</span>
          <span>{{certificateno.replace(/^(.{4})(?:\d+)(.{4})$/,"$1******$2")}}</span>
        </li>
        <li>
          <span>有效期至</span>
          <span>{{vailddate}}</span>
        </li>
        <li>
          <span>国籍</span>
          <span>中国</span>
        </li>
        <li>
          <span>职业</span>
          <span>{{occupation}}</span>
        </li>
        <li>
          <span>地址</span>
          <span>{{address}}</span>
        </li>
        <li>
          <span>实际控制人</span>
          <span>{{controller}}</span>
        </li>
        <!--  -->
        <li v-show="peopleTypeShow == '2'">
          <span>姓名</span>
          <span>{{peopleName}}</span>
        </li>
        <li v-show="peopleTypeShow == '2'">
          <span>证件类型</span>
          <span>{{peopleCertificatetype}}</span>
        </li>
        <li v-show="peopleTypeShow == '2'">
          <span>证件号码</span>
          <span>{{peopleCertificateno}}</span>
        </li>
        <li v-show="peopleTypeShow == '2'">
          <span>证件有效期</span>
          <span>{{peopleVailddate}}</span>
        </li>
        <li v-show="peopleTypeShow == '2'">
          <span>联系方式</span>
          <span>{{peoplePhone}}</span>
        </li>
        <!--  -->
        <li>
          <span>实际受益人</span>
          <span>{{beneficiary}}</span>
        </li>
        <li v-show="peopleTypeShow == '3'">
          <span>姓名</span>
          <span>{{peopleName}}</span>
        </li>
        <li v-show="peopleTypeShow == '3'">
          <span>证件类型</span>
          <span>{{peopleCertificatetype}}</span>
        </li>
        <li v-show="peopleTypeShow == '3'">
          <span>证件号码</span>
          <span>{{peopleCertificateno}}</span>
        </li>
        <li v-show="peopleTypeShow == '3'">
          <span>证件有效期</span>
          <span>{{peopleVailddate}}</span>
        </li>
        <li v-show="peopleTypeShow == '3'">
          <span>联系方式</span>
          <span>{{peoplePhone}}</span>
        </li>
      </ul>
    </div>
    <div v-show="idShow == '1'">
      <p class="myInfo-title">个税身份声明</p>
      <p style="height:32px;padding-left: 30px;">{{identification}}</p>
      <ul class="myInfo-personalInfo">
        <li v-show="identificationShow == 'fei'">
          <span>姓</span>
          <span>{{lastName}}</span>
        </li>
        <li v-show="identificationShow == 'fei'">
          <span>名</span>
          <span>{{firstName}}</span>
        </li>
        <li v-show="identificationShow == 'fei'">
          <span>性别</span>
          <span>{{gender}}</span>
        </li>
        <li v-show="identificationShow == 'fei'">
          <span>出生日期</span>
          <span>{{birthday2}}</span>
        </li>
        <li v-show="identificationShow == 'fei'">
          <span>现居地址</span>
          <span>{{liveAddress}}</span>
        </li>
        <li v-show="identificationShow == 'fei'">
          <span>出生地址</span>
          <span>{{birthAddress}}</span>
        </li>
        <li v-show="identificationShow1 == 'taxYes'">
          <span>税收居民国</span>
          <span>{{taxCountry}}</span>
        </li>
        <li v-show="identificationShow1 == 'taxYes'">
          <span>纳税人识别号</span>
          <span>{{taxNo}}</span>
        </li>
        <li v-show="identificationShow2 == 'taxNo1'">
          <p>居民国（地区）不发放纳税人识别号</p>
        </li>
        <li v-show="identificationShow3 == 'taxNo2'">
          <p>账户持有人未能取得纳税人识别号,具体原因如下：</p>
        </li>
        <li v-show="identificationShow3 == 'taxNo2'">
          <p>{{taxNoContent}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      peopleTypeShow: '1',
      id: Base64.decode(this.$commonJs.getCookie('u_id')),
      username: Base64.decode(this.$commonJs.getCookie('u_name1')),
      userInfo: '',
      // 个人信息
      phone: this.$commonJs.getCookie('u_phone1'),
      certificatetype: '--',
      certificateno: '--',
      vailddate: '--',
      occupation: '--',
      address: '--',
      controller: '--',
      beneficiary: '--',
      // 控制人、受益人信息
      peopleName: '--',
      peopleCertificatetype: '--',
      peopleCertificateno: '--',
      peopleVailddate: '--',
      peoplePhone: '--',
      // 个税身份声明
      identification: '--',
      idShow: '',
      identificationShow: '',
      identificationShow1: '',
      identificationShow2: '',
      identificationShow3: '',
      lastName: '',
      firstName: '',
      gender: '',
      birthday2: '',
      liveAddress: '',
      birthAddress: '',
      taxCountry: '',
      taxNo: '',
      taxNoContent: '',
      // 
      perfectText: '修改信息',
      step: '',
    }
  },
  created () {
  },
  mounted () {
    this.getData()
    this.getUserInfo()
  },
  methods: {
    // 全局数据
    getData () {
      this.$http.post(this.$apiPath.sessionId, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.loginflag == "false") {
          this.$commonJs.logout()
          this.$router.push({ name: 'logout' })
        }
        const info = res.data.data.custInfo
        if (info) {
          this.certificatetype = this.$parameterConfig.p_agentcertificatetype[info.certificatetype]
        }
      }).catch(error => { })
    },
    // 用户信息
    getUserInfo () {
      this.$http.post(this.$apiPath.queryAllInfo, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        // console.log(res);
        const account = res.data.data
        //判断信息完善的6要素
        if (account.accountInfo != null && account.accountInfo.profession != null && account.accountInfo.isIllegal != null && account.accountControl != null && account.accountTax != null && account.accountBenefit != null && account.accountIdcard != null) {//去掉了&& account.accountIdcard.address != null
          this.perfectText = '修改信息'
          this.step = 2
        } else if (account.accountInfo != null && account.accountInfo.profession != null && account.accountInfo.isIllegal != null && account.accountControl != null && account.accountTax != null && account.accountBenefit != null && account.accountIdcard == null) {
          this.perfectText = '未实名认证:立即认证'
          this.step = 1
        } else {
          this.perfectText = '信息未完善：立即完善'
          if (account.accountIdcard != null) {// 上传过身份证
            this.step = 2
          } else {
            this.step = 1
          }
        }
        // 绑上银行卡
        if (account.accountIdcard) {
          this.certificateno = account.accountIdcard.identify
          this.username = account.accountIdcard.name
          const valid = account.accountIdcard.valid;
          this.vailddate = valid == '长期' ? '长期' : this.$commonJs.getDateStrHg(valid)
        }
        //职业
        if (account.accountInfo && account.accountInfo.profession) {
          this.occupation = account.accountInfo.profession;
        }
        //地址
        if (account.accountAddress) {
          if (account.accountAddress.province == account.accountAddress.city) {
            this.address = (account.accountAddress.city ? account.accountAddress.city + "-" : '') + (account.accountAddress.area ? account.accountAddress.area + "-" : '') + account.accountAddress.address;
          } else {
            this.address = (account.accountAddress.province ? account.accountAddress.province + "-" : "") + (account.accountAddress.city ? account.accountAddress.city + "-" : '') + (account.accountAddress.area ? account.accountAddress.area + "-" : '') + account.accountAddress.address;
          }
        } else if (account.accountIdcard && account.accountIdcard.address) {
          this.address = account.accountIdcard.address;
        }
        //实际控制人
        if (account.accountControl) {
          if (account.accountControl.isControl == "1") {
            this.controller = '本人'
          } else {
            this.peopleTypeShow = '2'
            this.controller = '非本人'
            this.peopleName = account.accountControl.name
            this.certificatetype = this.$parameterConfig.p_agentcertificatetype[account.accountControl.identifyType]
            this.peopleCertificateno = account.accountControl.identifyNo
            this.peopleVailddate = this.$commonJs.getDateStrHg(account.accountControl.valid)
            this.peoplePhone = account.accountControl.contact
          }
        }
        //实际受益人
        if (account.accountBenefit) {
          if (account.accountBenefit.isBenefit == "1") {
            this.beneficiary = '本人'
          } else {
            this.peopleTypeShow = '3'
            this.beneficiary = '非本人'
            this.peopleName = account.accountBenefit.name
            this.certificatetype = this.$parameterConfig.p_agentcertificatetype[account.accountBenefit.identifyType]
            this.peopleCertificateno = account.accountBenefit.identifyNo
            this.peopleVailddate = this.$commonJs.getDateStrHg(account.accountBenefit.valid)
            this.peoplePhone = account.accountBenefit.contact
          }
        }
        //个税声明
        if (account.accountTax) {
          this.idShow = '1'
          if (account.accountTax.taxStatus == "1") {
            this.identification = "仅为中国税收居民";
          } else if (account.accountTax.taxStatus == "3") {
            this.identification = "既是中国税收居民又是其他国家（地区）税收居民";
          } else if (account.accountTax.taxStatus == "2") {
            this.identificationShow = 'fei'
            this.identification = "仅为非居民";
            this.lastName = account.accountTax.lastName;
            this.firstName = account.accountTax.firstName;
            this.gender = account.accountTax.gender;
            this.birthday2 = account.accountTax.birthday.slice(0, 4) + "-" + account.accountTax.birthday.slice(4, 6) + "-" + account.accountTax.birthday.slice(6, 8);
            this.liveAddress = this.lookCountryName(account.accountTax.liveCountry) + "-" + account.accountTax.liveCity + "-" + account.accountTax.liveAddress;
            this.birthAddress = this.lookCountryName(account.accountTax.birthCountry) + "-" + account.accountTax.birthCity;
            if (account.accountTax.provideTaxNo == "0") {
              if (account.accountTax.taxNoReason == "1") {
                this.identificationShow2 = 'taxNo1'
              } else if (account.accountTax.taxNoReason == "2") {
                this.identificationShow3 = 'taxNo2'
                this.taxNoContent = account.accountTax.taxNoContent;
              }
            } else if (account.accountTax.provideTaxNo == "1") {
              this.identificationShow1 = 'taxYes'
              this.taxCountry = this.lookCountryName(account.accountTax.taxCountry);
              this.taxNo = account.accountTax.taxNo;
            }
          }
        }
      }).catch(err => { })
    },
    perfectClick () {
      this.$router.push({
        name: 'perfectInformation',
        params: {
          flag: this.step
        }
      })
    },
    lookCountryName (shortName, className) {
      var sName = ''
      this.$store.state.countryList.forEach(function (val, ind) {
        if (val.short == shortName) {
          sName = val.name;
        }
      })
      return sName
    }


  }
}
</script>

<style lang="less" scoped>
.myInfo {
  &-header {
    height: 260px;
    // border-bottom: 1px solid #dedede;
    position: relative;
    img {
      width: 95px;
      height: 95px;
      position: absolute;
      margin: auto;
      top: 65px;
      left: 0;
      right: 0;
    }
  }
  &-attestation {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 171px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    background: @color;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
  &-username {
    position: absolute;
    top: 180px;
    left: 50%;
    font-size: 18px;
    color: @color6;
    transform: translateX(-50%);
  }
  &-con {
  }
  &-personalInfo {
    margin-bottom: 20px;
    padding-left: 30px;
    li {
      width: 100%;
      height: 52px;
      line-height: 52px;
      position: relative;
      box-sizing: border-box;
      span:nth-child(1) {
        font-size: 14px;
        font-weight: 500;
        color: #40403e;
        margin-right: 100px;
        // margin-top: 12px;
        display: inline-block;
        width: 85px;
        text-align: justify;
        text-align-last: justify;
        position: relative;
      }
    }
  }
  &-title {
    height: 27px;
    font-size: 18px;
    font-weight: bold;
    color: #246ead;
    line-height: 1;
    padding: 30px 0;
    padding-left: 30px;
    border-top: 1px solid #dedede;
  }
}
</style>